import React from "react";
import { useLang } from "../contexts/LangContext";
import { Globe2, Clock3, Wallet, Users } from "lucide-react";

const MoneyGramSection = () => {
  const { t } = useLang();
  const icons = [Clock3, Wallet, Users, Globe2];

  return (
    <section className="bg-burgundy text-white py-20 lg:py-28 relative overflow-hidden" data-testid="moneygram-section">
      <div
        className="absolute inset-0 opacity-15 pointer-events-none"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1620266757065-5814239881fd?w=1600&q=80)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-r from-[#5a1a14] via-[#5a1a14]/95 to-[#5a1a14]/80" />

      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="text-[10px] uppercase tracking-overline text-coral mb-4">
            {t.moneygram.kicker}
          </div>
          <h2 className="font-display font-black tracking-tight text-4xl lg:text-5xl">
            {t.moneygram.title}
          </h2>
          <p className="mt-6 text-white/75 font-light leading-relaxed max-w-md">
            {t.moneygram.desc}
          </p>
          <div className="mt-8 inline-block px-5 py-3 border border-white/30 font-mono-num text-sm">
            {t.moneygram.badge}
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/15">
          {t.moneygram.bullets.map((b, i) => {
            const Icon = icons[i] || Clock3;
            return (
              <div
                key={i}
                className="bg-burgundy p-8 flex items-start gap-4"
                data-testid={`mg-bullet-${i}`}
              >
                <div className="w-10 h-10 flex items-center justify-center border border-coral/40 text-coral shrink-0">
                  <Icon className="w-5 h-5" />
                </div>
                <p className="text-sm text-white/85 leading-relaxed">{b}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MoneyGramSection;
